import React, { Fragment } from 'react';
import { I18n } from 'common/i18n';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { Filters, getEnabledFilters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import SocrataIcon, { IconName } from 'common/components/SocrataIcon';
import Modal, { ModalHeader, ModalContent, ModalFooter } from 'common/components/Modal';
import { ForgeStack } from '@tylertech/forge-react';
import { Tab } from '../../lib/constants';
import { getFilterComponent } from './CatalogFilters';

import ActiveFilterCount from './active_filter_count';
import CategoryFilter from './category_filter';
import CustomFacetFilters from './custom_facet_filters';
import OwnedByFilter from './owned_by_filter';
import TagFilter from './tag_filter';
import RequesterFilter from './requester';

export const MobileCatalogFilters = ({
  filterOrder,
  activeTab,
  showAwaitingApprovalFilter,
  setAreMobileFiltersOpen,
}: {
  filterOrder: Filters[];
  activeTab: Tab;
  showAwaitingApprovalFilter: boolean;
  setAreMobileFiltersOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const dispatch: ThunkDispatch<any, unknown, AnyAction> = useDispatch();

  const clearAllFilters = () => {
    dispatch(filters.clearAllFilters({ shouldClearSearch: true }));
  };

  const toggleFilters = () => {
    setAreMobileFiltersOpen((prev) => !prev);
  };

  const filterHeader = (
    <div className="catalog-filters-header">
      {I18n.t('shared.asset_browser.mobile.filters')} <ActiveFilterCount />
      <a onClick={toggleFilters} className="done-button">
        {I18n.t('shared.asset_browser.mobile.done')}
      </a>
    </div>
  );

  const enabledFilters = getEnabledFilters(activeTab, showAwaitingApprovalFilter);

  const modalProps = {
    className: 'catalog-filters mobile',
    fullScreen: true,
    onDismiss: toggleFilters,
    overlay: true,
  };

  return (
    <Modal {...modalProps}>
      <ModalHeader onDismiss={toggleFilters} showCloseButton={false}>
        {filterHeader}
      </ModalHeader>
      <ModalContent>
        <div className="filter-content">
          <form>
            <div className="filter-switches">
              <ForgeStack gap={0}>
                {filterOrder.map((filterName) => {
                  return (
                    enabledFilters[filterName] && (
                      <Fragment key={filterName}>{getFilterComponent(filterName)}</Fragment>
                    )
                  );
                })}
              </ForgeStack>
            </div>
            {/* TODO EN-85150: Delete all filters below when autocomplete dropdown is converted to reusable component*/}
            {enabledFilters.ownedBy && <OwnedByFilter />}
            <div className="temp-extra-padding">
              {enabledFilters.visibility && getFilterComponent(Filters.Visibility)}
            </div>
            {enabledFilters.category && <CategoryFilter />}
            {enabledFilters.tag && <TagFilter />}
            {enabledFilters.customFacet && <CustomFacetFilters />}
            {enabledFilters.requester && <RequesterFilter />}
          </form>
        </div>
      </ModalContent>
      <ModalFooter>
        <a onClick={clearAllFilters} className="reset-filters">
          <SocrataIcon name={IconName.CloseCircle} />
          {I18n.t('shared.asset_browser.mobile.reset_filters')}
        </a>
        <button className="btn btn-default" onClick={toggleFilters}>
          {I18n.t('shared.asset_browser.mobile.done')}
        </button>
      </ModalFooter>
    </Modal>
  );
};
